import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../components/comman/Sidebar";
import StatisticsCard from "./StatisticsCard";
import BillingTypeAvgLagGraphCustomer from "./BillingTypeAvgLagGraphCustomer";
import BillingTypeAvgLagGraphBroker from "./BillingTypeAvgLagGraphBroker";
import ProjectHourGraph from "./ProjectHourGraph";
import BillingTrendGraph from "./BillingTrendGraph";
import BillingTrendGraphBroker from "./BillingTrendGraphBroker";
import CustomerGraph from "./CustomerGraph";
import BrokerGraph from "./BrokerGraph";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import NoRecordFound from "../comman/NoRecordFound";
import {
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
  Stack,
  TableSortLabel,
  Icon,
} from "@mui/material";
import Navbar from "../comman/Navbar";
import TextField from "@mui/material/TextField";
import {
  DatePicker,
  DesktopDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import React, { Component } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getAllCustomersList,
  getAllProjectsList,
  getAlluserList,
} from "../../redux/action";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader, getLogUserRole } from "../comman/MainFunction";
import API from "../comman/API";
import {
  CUSTOMER_LIST_URL,
  GET_ALL_CUSTOMERS_URL,
  GET_ALL_CUSTOMER_FILTER_URL,
  GET_BILLING_STATEMENT_DETAILS_BY_ID_URL,
  GET_BROKER_AVERAGE_LAG_GRAPH,
  GET_BROKER_BILLING_TYPE_GRAPH,
  GET_BROKER_PROJECT_HOURS,
  GET_DASHBOARD_BILLING_BY_DAY,
  GET_HEADER_STATISTICS_LIST,
  GET_DASHBOARD_FILTER_LIST,
  GET_PROJECT_BILLING_TYPE_GRAPH,
  GET_DASHBOARD_FILTER_BROKER_LIST,
} from "../../constants/ApiRoute";
import { date } from "yup";
import { useFormik } from "formik";
import { useToast } from "../comman/CustomMessages";
import dayjs from "dayjs";
import moment from "moment";
import CustomerTable from "./DashBoardBelowTable/CustomerTable";
import BrokerTable from "./DashBoardBelowTable/BrokerTable";
import BillingTable from "./DashBoardBelowTable/BillingTable";
import ActivityTable from "./DashBoardBelowTable/ActivityTable";
import { userRole } from "../comman/Constant";
import ProjectBrokersTable from "./DashBoardBelowTable/ProjectBrokersTable";
import ProjectBillingTable from "./DashBoardBelowTable/ProjectBillingTable";
import ProjectActivityTable from "./DashBoardBelowTable/ProjectAcivityTable";
import BrokerActivityTable from "./DashBoardBelowTable/BrokerActivity";
import BrokerBillingDetailsTable from "./DashBoardBelowTable/BrokerBillingDetails";
import BrokerBillingStatementTable from "./DashBoardBelowTable/BrokerBillingStatementTable";
import BrokerProjectTable from "./DashBoardBelowTable/BrokerProjectTable";
import CustomPagination from "./CustomPagination";
import CustomPageLoading from "../comman/CustomPageLoading";
import {
  BILLING_STATEMENT_LIST_ROUTE,
  DASHBOARD_ROUTE,
  INITIAL_ROUTE,
  SIGNIN_ROUTE,
} from "../../constants/RoutePath";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";

const Dashboard = () => {
  // const [value, setValue] = React.useState(0);
  const customerInitial = {
    customerId: "",
    projectId: "",
    brokerId: "",
  };

  const brokerInitial = {
    customerId: "",
    projectId: "",
    brokerId: "",
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [headerTab, setHeaderTab] = React.useState("Customers");
  const [customerTab, setCustomerTab] = React.useState(customerInitial);
  const [brokerTab, setBrokerTab] = React.useState(brokerInitial);
  console.log(brokerTab, "brokerrrrtababbabba", customerTab);
  const [userSession, setUserSession] = useState(() => {
    // Initialize session state from localStorage
    const session = localStorage.getItem("isLoggedIn");
    return session ? session : null;
  });
  const [customerTabProjectFilterArray, setCustomerTabProjectFilterArray] =
    React.useState([]);
  const [sideHeaderStatistics, setSideHeaderStatistics] = React.useState({
    Customer_KPI: 0,
    Customer_Desc: "",
    Project_KPI: 0,
    Project_Desc: "",
    Broker_KPI: 0,
    Broker_Desc: "",
    Billing_KPI: 0,
    Billing_Desc: "",
    Invoice_KPI: 0,
    Invoice_Desc: "",
  });
  const [projectBillingTypeGraph, SetProjectBillingTypeGraph] = React.useState(
    []
  );

  const [customerDropDownList, setCustomerDropDownList] = useState([]);
  const [brokerDropDownList, setBrokerDropDownList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [selectedBroker, setSelectedBroker] = useState({});
  const [resertValue, setResetvalue] = useState(false);

  console.log(resertValue, "brokerDropDownListbrokerDropDownList");

  // const top100Films = [
  //   { title: "The Shawshank Redemption", year: 1994 },
  //   { title: "The Godfather", year: 1972 },
  //   { title: "The Godfather: Part II", year: 1974 },
  //   { title: "The Dark Knight", year: 2008 },
  //   { title: "12 Angry Men", year: 1957 },
  //   { title: "Schindler's List", year: 1993 },
  //   { title: "Pulp Fiction", year: 1994 },
  //   {
  //     title: "The Lord of the Rings: The Return of the King",
  //     year: 2003,
  //   },
  // ];

  // const getSortIcon = (orderByValue) => {
  //   if (orderBy === orderByValue) {
  //     return order === "asc" ? (
  //       <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
  //     ) : (
  //       <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
  //     );
  //   } else {
  //     return <img src={sortuparrowIcon} className="sort-table-icon-both" />;
  //   }
  // };

  // For Deployment - 09-06-2024 - 5.00 PM

  const showToast = useToast();
  const [value, setValue] = React.useState(0);

  const [valueTopTap, setValueTopTap] = React.useState(11);
  console.log(value, "valueeeeeeeeeeeeee111111111111", valueTopTap);
  console.log(
    valueTopTap,
    "valueeeeeeeeeeeeee",
    customerTab.projectId == "" &&
      customerTab.customerId == "" &&
      customerTab.brokerId == ""
  );
  const [tableValues, setTableValues] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "broker",
    direction: "asc",
  });
  console.log(tableValues, "tableValuess");
  const [billingTypeGraph, setBillingTypeGraph] = useState([]);
  const [brokerAverageLag, setBrokerAverageLag] = useState([]);
  const [projectHourGrph, setProjectHourGrph] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  console.log(order, "orfeehjejejejejej", orderBy);
  const rowsPerPage = 5;
  const handleChange1 = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeTopTap = (event, newValue) => {
    console.log("new value -->", newValue);
    setValueTopTap(newValue ? 12 : 11);
  };

  const handleChangeBrokerTab = (event) => {
    getDashboardFilterBroker();

    let value = event.target.value;
    let name = event.target.name;

    if (name == "brokerId") {
      const selectedBroker = brokerDropDownList.find(
        (item) => item.BrokerID == value
      );
      setSelectedBroker(selectedBroker);

      setBrokerTab((prevState) => ({
        ...prevState,
        brokerId: value,
        customerId: "",
        projectId: "",
      }));
      // getBrokerBillingType(value);
      // getBrokerProjectHours(value);
      getBrokerAveragelag(value);
    } else if (name == "customerId") {
      setBrokerTab((prevState) => ({
        ...prevState,
        customerId: value,
        projectId: "",
      }));
    } else {
      setBrokerTab((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    // if (name == "customerId") {
    //   var projectFilteredArray = projectListSelList.filter(function (item) {
    //     return item.CustomerId === value;
    //   });
    //   setCustomerTabProjectFilterArray(projectFilteredArray);
    // } else if (name == "brokerId") {
    //   getBrokerBillingType(value);
    //   getBrokerProjectHours(value);
    // }
  };

  const handleChangeCustomerTab = (event) => {
    getDashboardFilter();
    setValue(0);
    let value = event.target.value;
    let name = event.target.name;

    if (name == "customerId") {
      const selectedCustomer = customerDropDownList.find(
        (item) => item.CustomerID == value
      );
      setSelectedCustomer(selectedCustomer);

      setCustomerTab((prevState) => ({
        ...prevState,
        customerId: value,
        projectId: "",
        brokerId: "",
      }));
    } else if (name == "projectId") {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: value,
        brokerId: "",
      }));
    } else if (name == "brokerId") {
      // getBrokerBillingType(value);
      // getBrokerProjectHours(value);
      getBrokerAveragelag(value);
      setCustomerTab((prevState) => ({
        ...prevState,
        brokerId: value,
      }));
    } else {
      setCustomerTab((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      var projectFilteredArray = projectListSelList.filter(function (item) {
        return item.CustomerId === value;
      });
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: "",
        brokerId: "",
      }));
      setCustomerTabProjectFilterArray(projectFilteredArray);
    }
  };

  // const handleChangeCustomerTab = (event) => {
  //   let value = event.target.value;
  //   let name = event.target.name;

  //   setCustomerTab((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));

  //   if (name == "customerId") {
  //     var projectFilteredArray = projectListSelList.filter(function (item) {
  //       return item.CustomerId === value;
  //     });
  //     setCustomerTabProjectFilterArray(projectFilteredArray);
  //   } else if (name == "brokerId") {
  //     getBrokerBillingType(value);
  //     getBrokerProjectHours(value);
  //   }
  // };

  const ResetTapFilter = (value) => {
    const currentDate = dayjs().format("MM/DD/YYYY");
    console.log(value, "currentDate654321");
    if (value == "type1") {
      setCustomerTab(customerInitial);
      setCustomerTabProjectFilterArray([]);
      getBillingSummaryDetails(currentDate);
      setValues((prev) => ({
        ...prev,
        date: dayjs().format("MM/DD/YYYY"),
      }));
      setHeaderTab("Customers");
      setBrokerTab(brokerInitial);
      getDashboardFilter();
    } else if (value == "type2") {
      setBrokerTab(brokerInitial);
      setCustomerTabProjectFilterArray([]);
      getBillingSummaryDetails(currentDate);
      setValues((prev) => ({
        ...prev,
        date: dayjs().format("MM/DD/YYYY"),
      }));
      setHeaderTab("Brokers");
      setCustomerTab(customerInitial);
      getDashboardFilterBroker();
    }
    setResetvalue(true);
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const topHeaderTapProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset to first page on search change
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const fieldsToSearch = ["BrokerName", "CustName", "ProjName", "Hours"];

  const filteredData = useMemo(() => {
    return tableValues.filter((item) =>
      fieldsToSearch.some((field) => {
        const fieldValue = item[field];
        return (
          fieldValue &&
          String(fieldValue).toLowerCase().includes(searchQuery.toLowerCase())
        );
      })
    );
  }, [searchQuery, tableValues]);

  console.log(filteredData, "filteredDatafilteredData");

  const sortedData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      const valueA = a[orderBy];
      const valueB = b[orderBy];

      // Ensure that we're sorting numbers if the field is numeric
      if (typeof valueA === "number" && typeof valueB === "number") {
        return order === "asc" ? valueA - valueB : valueB - valueA;
      } else {
        // For string fields, make the comparison case-insensitive
        const strA = valueA ? String(valueA).toLowerCase() : "";
        const strB = valueB ? String(valueB).toLowerCase() : "";

        if (strA < strB) {
          return order === "asc" ? -1 : 1;
        }
        if (strA > strB) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      }
    });
  }, [filteredData, orderBy, order]);

  console.log(sortedData, "sortedDatasortedData");

  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const paginatedData = useMemo(() => {
    return sortedData.slice(
      (page - 1) * rowsPerPage,
      (page - 1) * rowsPerPage + rowsPerPage
    );
  }, [sortedData, page, rowsPerPage]);

  const options = filteredData
    .map((item) => item.BrokerName)
    .filter((name) => name);

  const {
    handleSubmit,
    handleChange,
    values,
    setValues,
    errors,
    touched,
    resetForm,
    setFieldValue,
    setErrors,
    handleBlur,
    validateForm,
  } = useFormik({
    initialValues: {
      date: dayjs().format("MM/DD/YYYY"), // Initialize with the current date
    },
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const lineDateChange = (date, type) => {
    console.log("vdatedate", date);
    if (date && type != "onload") {
      // Convert the date to MM/DD/YYYY format
      const formattedDate = moment(date.toDate()).format("MM/DD/YYYY");
      console.log(formattedDate, "formatted date");
      setValues((prev) => ({
        ...prev,
        date: formattedDate,
      }));
      getBillingSummaryDetails(formattedDate); // Ensure this function is defined
    } else if (date && type == "onload") {
      getBillingSummaryDetails(date);
    }
  };

  // const sortedData = [...filteredData].sort((a, b) => {
  //   if (a[sortConfig.key] < b[sortConfig.key]) {
  //     return sortConfig.direction === "asc" ? -1 : 1;
  //   }
  //   if (a[sortConfig.key] > b[sortConfig.key]) {
  //     return sortConfig.direction === "asc" ? 1 : -1;
  //   }
  //   return 0;
  // });

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";
    console.log(property, "peieoiiroiorioriori", isAsc, orderValue);

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    // setSortClickedTime(new Date().toLocaleString());
    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const getBillingSummaryDetails = async (date) => {
    setLoading(true);
    let data = {
      date: date ? date : values.date,
    };
    const config = {
      method: "GET",
      url: GET_DASHBOARD_BILLING_BY_DAY,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        console.log(data, "dataaaaaaaa", data != {} ? "yes" : "Noooo");
        setTableValues(data?.length ? data : []);
        // if (parsedResponse.billingStatementDetails) {
        // setResponseBill(parsedResponse.billingStatementDetails);
        // }/
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getBrokerBillingType = async (brokerid) => {
    let data = {
      userId: brokerid ? brokerid : customerTab.brokerId,
    };
    const config = {
      method: "GET",
      url: GET_BROKER_BILLING_TYPE_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    console.log("API_CALLING+_DASHBOARFD");
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setBillingTypeGraph(data);
        console.log("API_CALLING123");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
    } finally {
    }
  };
  const getBrokerAveragelag = async (brokerid) => {
    let data = {
      userId: brokerid ? brokerid : customerTab.brokerId,
    };
    const config = {
      method: "GET",
      url: GET_BROKER_AVERAGE_LAG_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    console.log("API_CALLING+_DASHBOARFD");
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setBrokerAverageLag(data);
        console.log("API_CALLING123");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
    } finally {
    }
  };

  // Customer DropDown List
  const getDashboardFilter = async () => {
    const config = {
      method: "GET",
      url: GET_DASHBOARD_FILTER_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(customerInitial)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setCustomerDropDownList(data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
    }
  };

  // Broker DropDown List
  const getDashboardFilterBroker = async () => {
    const config = {
      method: "GET",
      url: GET_DASHBOARD_FILTER_BROKER_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(customerInitial)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const brokerData = data.filter(
          (item) => item.BrokerID !== null && item.BrokerID !== ""
        );
        setBrokerDropDownList(brokerData);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
    } finally {
    }
  };

  const getHeaderStatistics = async () => {
    const config = {
      method: "GET",
      url: GET_HEADER_STATISTICS_LIST,
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setSideHeaderStatistics(data[0]);
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    }
  };

  const getProjectBillingTypeGraph = async () => {
    if (customerTab.projectId) {
      let data = {
        projectId: customerTab.projectId,
      };
      const config = {
        method: "GET",
        url: GET_PROJECT_BILLING_TYPE_GRAPH,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        const { status, data } = parsedResponse;
        if (status === "Success") {
          SetProjectBillingTypeGraph(data);

          console.log("parsedResponse", parsedResponse);
        }
      } catch (error) {
        console.log(" Error Meassage For Statistic", error);
      }
    }
  };

  useEffect(() => {
    getDashboardFilter();
    getDashboardFilterBroker();
    getHeaderStatistics();
    if (values && values.date) {
      lineDateChange(values.date, "onload");
    }
  }, []);

  useEffect(() => {
    setPageLoading(true);
    setTimeout(() => {
      setPageLoading(false);
    }, 3000);
    getHeaderStatistics();
  }, [customerTab, brokerTab]);

  // useEffect(() => {
  //   getProjectBillingTypeGraph();
  // }, [customerTab.projectId]);

  const logoutChannel = new BroadcastChannel("logout-channel");
  const loginChannel = new BroadcastChannel("login-channel");

  const [isLeavingDashboard, setIsLeavingDashboard] = useState(false);

  useEffect(() => {
    const { pathname } = window.location;
    const DASHBOARD_ROUTE = "/dashboard";
    console.log(pathname, "pathanamama", userSession);

    const handlePopState = (event) => {
      const currentPath = window.location.pathname;

      if (currentPath == DASHBOARD_ROUTE && userSession == "true") {
        // setIsLeavingDashboard(true); // Set state to show confirmation
        event.preventDefault(); // Prevent default navigation
        window.history.pushState(null, document.title, window.location.href); // keep the user on the current page
      }else {
        setIsLeavingDashboard(false);
        window.history.pushState(null, document.title, window.location.href); 
        // Stay on dashboard, already handled by pushState
      }
    };

    window.addEventListener("popstate", handlePopState);
    logoutChannel.addEventListener("popstate", handlePopState);


    return () => {
      window.removeEventListener("popstate", handlePopState);
      logoutChannel.removeEventListener("popstate", handlePopState);

    };
  }, [userSession]);

  useEffect(() => {
    if (isLeavingDashboard) {
      const confirmation = window.confirm("Are you sure you want to sign out?");

      if (confirmation)   {
              setIsLeavingDashboard(false);
        
              // Clear session data & broadcast logout event
              localStorage.clear();
              localStorage.setItem("logout", Date.now()); // Broadcast logout event
        
              window.location.reload();
              navigate(SIGNIN_ROUTE, { replace: true });
            } else {
              setIsLeavingDashboard(false);
              window.history.pushState({}, document.title, window.location.href); 
              // Stay on dashboard, already handled by pushState
            }
    }
  }, [isLeavingDashboard]);

  const handleProjectNavigate = (val, CustID) => {
    if (valueTopTap == "11") {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
        brokerId: "",
      }));
    } else {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
      }));
    }
  };

  useEffect(() => {
    getBillingSummaryDetails(values?.date);
  }, [order, orderBy]);
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Sidebar higlightSide={"0"} />
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title="Dashboard" />

          {/* Tab Section Start */}
          <Box className="bg-box dashboard-bg-box">
            <Grid container>
              <Grid xs={12} md={12}>
                <Box sx={{ width: "100%" }}>
                  <Box
                    className="dashboard-tabs first-tab"
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                  >
                    <Tabs
                      value={valueTopTap}
                      onChange={handleChangeTopTap}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        label="Customers"
                        className={
                          headerTab == "Customers"
                            ? "active-customer-tap-dashboard"
                            : " "
                        }
                        style={
                          headerTab == "Customers" ? { color: "#58a84a" } : {}
                        }
                        {...topHeaderTapProps(11)}
                        onClick={() => {
                          setHeaderTab("Customers");
                          setBrokerTab(brokerInitial);
                          getDashboardFilter();
                          setResetvalue(true);
                        }}
                      />
                      <Tab
                        className={
                          headerTab == "Brokers"
                            ? "active-customer-tap-dashboard"
                            : " "
                        }
                        label="Brokers"
                        style={
                          headerTab == "Brokers" ? { color: "#58a84a" } : {}
                        }
                        {...topHeaderTapProps(12)}
                        onClick={() => {
                          setHeaderTab("Brokers");
                          setCustomerTab(customerInitial);
                          getDashboardFilterBroker();
                        }}
                      />
                    </Tabs>
                  </Box>

                  {/* Customer */}
                  <CustomTabPanel
                    className="dashboard-tab-content"
                    value={valueTopTap}
                    index={11}
                  >
                    <Stack
                      direction={{ xs: "column", sm: "row", md: "row" }}
                      alignItems={{
                        xs: "flex-start",
                        sm: "center",
                        md: "center",
                      }}
                      justifyContent="space-between"
                    >
                      <Box sx={{ pt: "0px !important" }}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            sx={{
                              ".MuiSelect-select": {
                                color:
                                  customerTab.customerId === ""
                                    ? "#898989 !important"
                                    : "#212121 !important",
                              },
                            }}
                            name="customerId"
                            value={customerTab.customerId}
                            onChange={handleChangeCustomerTab}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value="">Select Customer</MenuItem>
                            {/* {customerDropDownList
                              .filter((item) => item.CustomerActive == 1)
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.CustomerID}
                                  value={item.CustomerID}
                                >
                                  {item.CustomerName}
                                </MenuItem>
                              ))} */}

                            {customerDropDownList
                              .filter(
                                (item) =>
                                  item.CustomerActive == 1 && // Check if the customer is active
                                  item.projectDetails.some(
                                    (projectItem) =>
                                      projectItem.ProjectActive == 1 && // Check if at least one project is active
                                      projectItem.brokerDetails && // Ensure brokerDetails exists
                                      projectItem.brokerDetails.length > 0 // Check if brokerDetails array is not empty
                                  )
                              )
                              .sort((a, b) =>
                                a.CustomerName.localeCompare(b.CustomerName)
                              )
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.CustomerID}
                                  value={item.CustomerID}
                                >
                                  {item.CustomerName}{" "}
                                  {/* Display customer name */}
                                </MenuItem>
                              ))}
                          </Select>

                          {/* <FormHelperText>Without label</FormHelperText> */}
                        </FormControl>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            sx={{
                              ".MuiSelect-select": {
                                color:
                                  customerTab.projectId === ""
                                    ? "#898989 !important"
                                    : "#212121 !important",
                              },
                            }}
                            name="projectId"
                            value={customerTab.projectId}
                            onChange={handleChangeCustomerTab}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value="">Select Project</MenuItem>

                            {customerDropDownList
                              .find(
                                (customer) =>
                                  customer.CustomerID === customerTab.customerId
                              )
                              ?.projectDetails.filter(
                                (item) => item.ProjectActive == 1
                              )
                              .sort((a, b) =>
                                a.ProjectName.localeCompare(b.ProjectName)
                              )
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.ProjectID}
                                  value={item.ProjectID}
                                >
                                  {item.ProjectName}
                                </MenuItem>
                              ))}
                          </Select>
                          {/* <FormHelperText>Without label</FormHelperText> */}
                        </FormControl>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            sx={{
                              ".MuiSelect-select": {
                                color:
                                  customerTab.brokerId === ""
                                    ? "#898989 !important"
                                    : "#212121 !important",
                              },
                            }}
                            name="brokerId"
                            value={customerTab.brokerId}
                            onChange={handleChangeCustomerTab}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value="">Select Broker</MenuItem>

                            {customerDropDownList
                              .find(
                                (customer) =>
                                  customer.CustomerID === customerTab.customerId
                              )
                              ?.projectDetails.find(
                                (project) =>
                                  project.ProjectActive == 1 &&
                                  project.ProjectID === customerTab.projectId
                              )
                              ?.brokerDetails // .filter(
                              //   (item) => item.UserActive == 1
                              // )
                              .sort((a, b) =>
                                a.BrokerName.localeCompare(b.BrokerName)
                              )
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.BrokerID}
                                  value={item.BrokerID}
                                >
                                  {item.BrokerName}
                                </MenuItem>
                              ))}
                          </Select>
                          {/* <FormHelperText>Without label</FormHelperText> */}
                        </FormControl>
                      </Box>
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">history</span>
                        }
                        className="reset-btn"
                        onClick={() => ResetTapFilter("type1")}
                      >
                        Reset
                      </Button>
                    </Stack>
                  </CustomTabPanel>

                  {/* Broker */}
                  <CustomTabPanel
                    className="dashboard-tab-content"
                    value={valueTopTap}
                    index={12}
                  >
                    <Stack
                      direction={{ xs: "column", sm: "row", md: "row" }}
                      alignItems={{
                        xs: "flex-start",
                        sm: "center",
                        md: "center",
                      }}
                      justifyContent="space-between"
                    >
                      <Box sx={{ pt: "0px !important" }}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            sx={{
                              ".MuiSelect-select": {
                                color:
                                  brokerTab.brokerId === ""
                                    ? "#898989 !important"
                                    : "#212121 !important",
                              },
                            }}
                            name="brokerId"
                            value={brokerTab.brokerId}
                            onChange={handleChangeBrokerTab}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value="">Select Broker</MenuItem>
                            {/* {brokerDropDownList
                              // .filter((item) => item.UserActive == 1)
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.BrokerID}
                                  value={item.BrokerID}
                                >
                                  {item.BrokerName}
                                </MenuItem>
                              ))} */}
                            {brokerDropDownList
                              .filter((broker) =>
                                broker.customerDetails.some(
                                  (customer) =>
                                    customer.CustomerActive == 1 &&
                                    customer.projectDetails.some(
                                      (project) => project.ProjectActive == 1
                                    )
                                )
                              )
                              .sort((a, b) =>
                                a.BrokerName.localeCompare(b.BrokerName)
                              )
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.BrokerID}
                                  value={item.BrokerID}
                                >
                                  {item.BrokerName}
                                </MenuItem>
                              ))}
                          </Select>
                          {/* <FormHelperText>Without label</FormHelperText> */}
                        </FormControl>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            sx={{
                              ".MuiSelect-select": {
                                color:
                                  brokerTab.customerId === ""
                                    ? "#898989 !important"
                                    : "#212121 !important",
                              },
                            }}
                            name="customerId"
                            value={brokerTab.customerId}
                            onChange={handleChangeBrokerTab}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value="">Select Customer</MenuItem>
                            {brokerDropDownList
                              .find(
                                (broker) =>
                                  // broker.UserActive == 1 &&
                                  broker.BrokerID === brokerTab.brokerId
                              )
                              ?.customerDetails.filter(
                                (item) => item.CustomerActive == 1
                              )
                              .sort((a, b) =>
                                a.CustomerName.localeCompare(b.CustomerName)
                              )
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.CustomerID}
                                  value={item.CustomerID}
                                >
                                  {item.CustomerName}
                                </MenuItem>
                              ))}
                          </Select>
                          {/* <FormHelperText>Without label</FormHelperText> */}
                        </FormControl>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            sx={{
                              ".MuiSelect-select": {
                                color:
                                  brokerTab.projectId === ""
                                    ? "#898989 !important"
                                    : "#212121 !important",
                              },
                            }}
                            name="projectId"
                            value={brokerTab.projectId}
                            onChange={handleChangeBrokerTab}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value="">Select Project</MenuItem>
                            {brokerDropDownList
                              .find(
                                (broker) =>
                                  // broker.UserActive == 1 &&
                                  broker.BrokerID === brokerTab.brokerId
                              )
                              ?.customerDetails.find(
                                (customer) =>
                                  customer.CustomerActive == 1 &&
                                  customer.CustomerID === brokerTab.customerId
                              )
                              ?.projectDetails.filter(
                                (item) => item.ProjectActive == 1
                              )
                              .sort((a, b) =>
                                a.ProjectName.localeCompare(b.ProjectName)
                              )
                              .map((item) => (
                                <MenuItem
                                  className="dashboard-select-option"
                                  key={item.ProjectID}
                                  value={item.ProjectID}
                                >
                                  {item.ProjectName}
                                </MenuItem>
                              ))}
                          </Select>
                          {/* <FormHelperText>Without label</FormHelperText> */}
                        </FormControl>
                      </Box>
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">history</span>
                        }
                        className="reset-btn"
                        onClick={() => ResetTapFilter("type2")}
                      >
                        Reset
                      </Button>
                    </Stack>
                  </CustomTabPanel>
                </Box>
              </Grid>
            </Grid>
          </Box>
          {/* Tab Section End */}

          <Grid sx={{ mt: "15px" }} container>
            <Grid xs={12} md={8}>
              {/* Billing Trend graph for both - customer and broker */}
              <BillingTrendGraph
                headerTab={headerTab}
                customerTab={customerTab}
                brokerTab={brokerTab}
                selectedBroker={selectedBroker}
                setSelectedBroker={setSelectedBroker}
                selectedCustomer={selectedCustomer}
                brokerDropDownList={brokerDropDownList}
                resertValue={resertValue}
                setResetvalue={setResetvalue}
              />

              {/* Broker billing trend */}

              {headerTab === "Customers" && customerTab.brokerId ? (
                <BillingTrendGraphBroker
                  headerTab={headerTab}
                  customerTab={customerTab}
                  brokerTab={brokerTab}
                  selectedBroker={selectedBroker}
                  selectedCustomer={selectedCustomer}
                />
              ) : (
                ""
              )}

              {/* Custpmer count and broker count graph - only customer tap */}

              {headerTab === "Customers" &&
              (customerTab.customerId || customerTab.projectId) &&
              !customerTab.brokerId ? (
                <CustomerGraph
                  headerTab={headerTab}
                  customerTab={customerTab}
                  brokerTab={brokerTab}
                  selectedCustomer={selectedCustomer}
                />
              ) : (
                ""
              )}

              {/* broker count and broker count graph - only broker tap */}

              {headerTab === "Brokers" &&
              brokerTab.brokerId &&
              brokerTab.customerId ? (
                <BrokerGraph
                  headerTab={headerTab}
                  customerTab={customerTab}
                  brokerTab={brokerTab}
                  selectedBroker={selectedBroker}
                />
              ) : (
                ""
              )}

              {/* Project Hour For All  */}

              {(brokerTab.brokerId &&
                !brokerTab.customerId &&
                !brokerTab.projectId) ||
              customerTab.brokerId ? (
                <ProjectHourGraph
                  brokerTab={brokerTab}
                  customerTab={customerTab}
                  selectedCustomer={selectedCustomer}
                  selectedBroker={selectedBroker}
                />
              ) : (
                ""
              )}
            </Grid>

            <Grid xs={12} md={4}>
              <StatisticsCard statistics={sideHeaderStatistics} />

              {/* billing type for customer */}

              {headerTab === "Customers" &&
              (customerTab.customerId ||
                customerTab.projectId ||
                customerTab.brokerId) ? (
                <BillingTypeAvgLagGraphCustomer
                  headerTab={headerTab}
                  customerTab={customerTab}
                  brokerTab={brokerTab}
                  selectedCustomer={selectedCustomer}
                />
              ) : (
                ""
              )}

              {/* billing type for broker */}

              {headerTab === "Brokers" &&
              (brokerTab.customerId ||
                brokerTab.projectId ||
                brokerTab.brokerId) ? (
                <BillingTypeAvgLagGraphBroker
                  headerTab={headerTab}
                  customerTab={customerTab}
                  brokerTab={brokerTab}
                  selectedBroker={selectedBroker}
                />
              ) : (
                ""
              )}
            </Grid>
          </Grid>

          {pageLoading ? <CustomPageLoading /> : ""}

          {((valueTopTap == "11" &&
            customerTab.projectId == "" &&
            customerTab.customerId == "" &&
            customerTab.brokerId == "") ||
            (valueTopTap == "12" &&
              brokerTab.projectId == "" &&
              brokerTab.customerId == "" &&
              brokerTab.brokerId == "")) && (
            <Box className="bg-box user-log" sx={{ mt: "15px" }}>
              <Grid container>
                <Grid xs={12} md={12}>
                  <Typography className="billing-sum-title">
                    Billing Summary By Day:
                  </Typography>
                  <Stack
                    sx={{ mt: "23px", mb: "15px" }}
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    alignItems={{ xs: "baseline", sm: "center", md: "center" }}
                    justifyContent="space-between"
                  >
                    <Autocomplete
                      sx={{ maxWidth: "265px", width: "100%" }}
                      freeSolo
                      id="free-solo-2-demo"
                      disableClearable
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="material-symbols-outlined">
                            search
                          </span>
                        </InputAdornment>
                      }
                      options={[]}
                      onInputChange={handleSearchChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search"
                          InputProps={{
                            ...params.InputProps,
                            type: "search",
                          }}
                        />
                      )}
                    />
                    <LocalizationProvider
                      sx={{
                        mt: { xs: "10px", md: "0px" },
                        maxWidth: "265px",
                        width: "100%",
                      }}
                      dateAdapter={AdapterDayjs}
                    >
                      {/* <DemoContainer components={["DatePicker"]}> */}
                      {/* <DemoItem> */}
                      <DesktopDatePicker
                        sx={{ mt: { xs: "10px", md: "0px" } }}
                        inputFormat="MM/DD/YYYY"
                        name="date"
                        onChange={lineDateChange}
                        value={dayjs(values.date, "MM/DD/YYYY")} // Use dayjs to parse the formatted date
                        renderInput={(params) => <TextField {...params} />}
                      />
                      {/* </DemoItem>
                   </DemoContainer> */}
                    </LocalizationProvider>
                  </Stack>
                  <TableContainer
                    sx={{
                      boxShadow: "none",
                      overflowX: "auto",
                      maxWidth: { xs: "350px", md: "100%" },
                    }}
                    component={Paper}
                  >
                    <Table
                      sx={{
                        minWidth: { xs: "unset", md: 650 },
                      }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <TableSortLabel
                              active={orderBy === "BrokerName"}
                              direction={
                                orderBy === "BrokerName" ? order : "asc"
                              }
                              onClick={() => handleSort("BrokerName")}
                              IconComponent={() => getSortIcon("BrokerName")}
                              style={
                                orderBy === "BrokerName"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                              // active={sortConfig.key === "BrokerName"}
                              // direction={sortConfig.direction}
                              // onClick={() => handleSort("BrokerName")}
                            >
                              Broker
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={orderBy === "CustName"}
                              direction={orderBy === "CustName" ? order : "asc"}
                              onClick={() => handleSort("CustName")}
                              IconComponent={() => getSortIcon("CustName")}
                              style={
                                orderBy === "CustName"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                              // active={sortConfig.key === "CustName"}
                              // direction={sortConfig.direction}
                              // onClick={() => handleSort("CustName")}
                            >
                              Customers
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={orderBy === "ProjName"}
                              direction={orderBy === "ProjName" ? order : "asc"}
                              onClick={() => handleSort("ProjName")}
                              IconComponent={() => getSortIcon("ProjName")}
                              style={
                                orderBy === "ProjName"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                              // active={sortConfig.key === "ProjName"}
                              // direction={sortConfig.direction}
                              // onClick={() => handleSort("ProjName")}
                            >
                              Project
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={orderBy === "Hours"}
                              direction={orderBy === "Hours" ? order : "asc"}
                              onClick={() => handleSort("Hours")}
                              IconComponent={() => getSortIcon("Hours")}
                              style={
                                orderBy === "Hours" ? { color: "#007fff" } : {}
                              }
                              // active={sortConfig.key === "Hours"}
                              // direction={sortConfig.direction}
                              // onClick={() => handleSort("Hours")}
                            >
                              Hours
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {loading ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              <CircularProgress disableShrink />
                            </TableCell>
                          </TableRow>
                        ) : paginatedData.length > 0 ? (
                          paginatedData.map((val, index) => (
                            <TableRow key={index}>
                              <TableCell
                                sx={{
                                  wordBreak: "break-word",
                                  minWidth: "170px",
                                }}
                              >
                                {val.BrokerName ? val.BrokerName : "-"}
                              </TableCell>
                              <TableCell>
                                <span style={{ wordBreak: "break-word" }}>
                                  {val.CustName ? val.CustName : "-"}
                                </span>
                              </TableCell>
                              <TableCell
                                // className="bill-summary-td"
                                sx={
                                  val.ProjID
                                    ? {
                                        color: "#007FFF !important",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }
                                    : {}
                                }
                                onClick={() =>
                                  handleProjectNavigate(val.ProjID)
                                }
                              >
                                <span
                                  style={{
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {val.ProjName ? val.ProjName : "-"}
                                </span>
                              </TableCell>
                              <TableCell sx={{ textAlign: "center" }}>
                                {val.Hours ? val.Hours : "0"}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              {/* <Typography>No Record Found</Typography> */}
                              <NoRecordFound />
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    {paginatedData?.length > 0 && (
                      <Pagination
                        sx={{ mt: "13.5px", float: "right" }}
                        shape="rounded"
                        // hidePrevButton
                        // hideNextButton
                        renderItem={(item) => (
                          <PaginationItem
                            components={{
                              previous: () => (
                                <Icon className="material-symbols-outlined">
                                  keyboard_backspace
                                </Icon>
                              ),
                              next: () => (
                                <Icon className="material-symbols-outlined">
                                  east
                                </Icon>
                              ),
                            }}
                            {...item}
                          />
                        )}
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                      />
                    )}
                  </TableContainer>
                </Grid>
              </Grid>
            </Box>
          )}
          {(valueTopTap == "11" &&
            customerTab.customerId &&
            customerTab.projectId == "" &&
            customerTab.brokerId == "") ||
          (valueTopTap == "12" &&
            brokerTab.customerId &&
            brokerTab.projectId == "" &&
            brokerTab.brokerId) ? (
            <Box className="bg-box" sx={{ mt: "15px" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Box sx={{ width: "100%" }}>
                    <Box
                      className="dashboard-tabs"
                      sx={{ borderBottom: 1, borderColor: "divider" }}
                    >
                      <Tabs
                        value={value}
                        onChange={handleChange1}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Projects" {...a11yProps(0)} />
                        <Tab label="Brokers" {...a11yProps(1)} />
                        <Tab label="Billing" {...a11yProps(1)} />
                        <Tab label="Activity" {...a11yProps(1)} />
                      </Tabs>
                    </Box>

                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={0}
                    >
                      <CustomerTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={1}
                    >
                      <BrokerTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                        selectedBroker={selectedBroker}
                        setSelectedBroker={setSelectedBroker}
                        brokerDropDownList={brokerDropDownList}
                        brokerTab={brokerTab}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={2}
                    >
                      <BillingTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={3}
                    >
                      <ActivityTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ) : (((valueTopTap == "11" && customerTab.customerId) ||
              customerTab.customerId == "") &&
              customerTab.projectId &&
              customerTab.brokerId == "") ||
            (valueTopTap == "12" &&
              brokerTab.brokerId &&
              brokerTab.projectId &&
              (brokerTab.customerId == "" || brokerTab.customerId)) ? (
            <Box className="bg-box" sx={{ mt: "15px" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Box sx={{ width: "100%" }}>
                    <Box
                      className="dashboard-tabs"
                      sx={{ borderBottom: 1, borderColor: "divider" }}
                    >
                      <Tabs
                        value={value}
                        onChange={handleChange1}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Brokers" {...a11yProps(0)} />
                        <Tab label="Billing" {...a11yProps(1)} />
                        <Tab label="Activity" {...a11yProps(1)} />
                      </Tabs>
                    </Box>

                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={0}
                    >
                      {console.log("id of bre", brokerTab, valueTopTap)}

                      <ProjectBrokersTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                        selectedBroker={selectedBroker}
                        setSelectedBroker={setSelectedBroker}
                        brokerDropDownList={brokerDropDownList}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={1}
                    >
                      <ProjectBillingTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={2}
                    >
                      <ProjectActivityTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ) : (((valueTopTap == "11" && customerTab.customerId) ||
              customerTab.customerId == "") &&
              (customerTab.projectId || customerTab.projectId == "") &&
              customerTab.brokerId) ||
            (valueTopTap == "12" &&
              (brokerTab.customerId || brokerTab.customerId == "") &&
              (brokerTab.projectId || brokerTab.projectId == "") &&
              brokerTab.brokerId) ? (
            <Box className="bg-box" sx={{ mt: "15px" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Box sx={{ width: "100%" }}>
                    <Box
                      className="dashboard-tabs"
                      sx={{ borderBottom: 1, borderColor: "divider" }}
                    >
                      <Tabs
                        value={value}
                        onChange={handleChange1}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Projects" {...a11yProps(0)} />
                        <Tab label="Billing Statements" {...a11yProps(1)} />
                        <Tab label="Billing Details" {...a11yProps(1)} />
                        <Tab label="Activity" {...a11yProps(1)} />
                      </Tabs>
                    </Box>

                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={0}
                    >
                      <BrokerProjectTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={1}
                    >
                      <BrokerBillingStatementTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={2}
                    >
                      <BrokerBillingDetailsTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                    {/* Customer */}
                    <CustomTabPanel
                      className="dashboard-tab-content"
                      value={value}
                      index={3}
                    >
                      <BrokerActivityTable
                        customerTab={
                          valueTopTap == "11" ? customerTab : brokerTab
                        }
                        setCustomerTab={
                          valueTopTap == "11" ? setCustomerTab : setBrokerTab
                        }
                        valueTopTap={valueTopTap}
                      />
                    </CustomTabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;
